import React, { useEffect, useState } from 'react';
import { useUser } from '../context/UserContext';
import { createTask, getUsers } from '../services/api';

interface TaskFromContextModalProps {
  entityType: 'student' | 'prospect' | 'lead';
  entityId: string;
  sourceType: 'document' | 'communication';
  sourceName: string;
  sourceLink?: string;
  onClose: () => void;
  onCreated: () => void;
}

export default function TaskFromContextModal({
  entityType, entityId, sourceType, sourceName, sourceLink, onClose, onCreated
}: TaskFromContextModalProps) {
  const { userName } = useUser();
  const [users, setUsers] = useState<any[]>([]);
  const [form, setForm] = useState({
    title: sourceType === 'document' ? `משימה עבור מסמך: ${sourceName}` : `משימה עבור: ${sourceName}`,
    description: '',
    assignedTo: '',
    ccTo: '',
    dueDate: '',
    priority: 'normal',
    notes: '',
  });

  useEffect(() => {
    getUsers().then(res => setUsers(res.data)).catch(() => {});
  }, []);

  const handleSave = async () => {
    const taskData = {
      ...form,
      taskType: sourceType === 'document' ? 'document_based' : 'event_based',
      relatedDocument: sourceType === 'document' ? sourceName : '',
      relatedEvent: sourceType === 'communication' ? sourceName : '',
      relatedEntityType: entityType,
      relatedEntityId: entityId,
      createdBy: userName,
      status: 'new',
    };
    await createTask(taskData);
    onCreated();
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 550 }}>
        <div className="modal-header">
          <h3 className="modal-title">📋 יצירת משימה {sourceType === 'document' ? 'ממסמך' : 'מאירוע'}</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div style={{ maxHeight: '65vh', overflowY: 'auto' }}>
          <div className="form-group">
            <label className="form-label">מקור</label>
            <div className="form-input" style={{ background: '#f3e5f5', display: 'flex', alignItems: 'center', gap: 8 }}>
              <span>{sourceType === 'document' ? '📄' : '📨'}</span>
              {sourceLink ? (
                <a href={sourceLink} target="_blank" rel="noopener noreferrer" style={{ color: '#7B1FA2', fontWeight: 500 }}>
                  {sourceName}
                </a>
              ) : (
                <strong style={{ color: '#7B1FA2' }}>{sourceName}</strong>
              )}
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">כותרת המשימה *</label>
            <input className="form-input" value={form.title} onChange={e => setForm({...form, title: e.target.value})} />
          </div>
          <div className="form-group">
            <label className="form-label">תיאור</label>
            <textarea className="form-textarea" value={form.description} onChange={e => setForm({...form, description: e.target.value})} />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">מבצע המשימה</label>
              <select className="form-select" value={form.assignedTo} onChange={e => setForm({...form, assignedTo: e.target.value})}>
                <option value="">-- בחר מבצע --</option>
                {users.map(u => (
                  <option key={u.id} value={u.id}>{u.name}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">לידיעה</label>
              <select className="form-select" value={form.ccTo} onChange={e => setForm({...form, ccTo: e.target.value})}>
                <option value="">-- ללא --</option>
                {users.map(u => (
                  <option key={u.id} value={u.id}>{u.name}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">תאריך יעד</label>
              <input className="form-input" type="date" value={form.dueDate} onChange={e => setForm({...form, dueDate: e.target.value})} />
            </div>
            <div className="form-group">
              <label className="form-label">עדיפות</label>
              <select className="form-select" value={form.priority} onChange={e => setForm({...form, priority: e.target.value})}>
                <option value="low">נמוכה</option>
                <option value="normal">רגילה</option>
                <option value="high">גבוהה</option>
                <option value="urgent">דחופה</option>
              </select>
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">נוצר על ידי</label>
            <div className="form-input" style={{ background: '#f8f9fa' }}>{userName}</div>
          </div>
          <div className="form-group">
            <label className="form-label">הערות</label>
            <textarea className="form-textarea" value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} />
          </div>
        </div>
        <div className="modal-actions">
          <button className="btn btn-primary" onClick={handleSave} disabled={!form.title}>📋 צור משימה</button>
          <button className="btn btn-outline" onClick={onClose}>ביטול</button>
        </div>
      </div>
    </div>
  );
}
